import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({ id: 'setup.startEndRoute.header.title' }),
      description: translate({ id: 'setup.startEndRoute.header.description' }),
    },
    collect: translate({ id: 'setup.startEndRoute.collect.title' }),
  }))

  return api
}
